import { useStyles } from "./Guest.style";
import { getImage3x } from "../../models/theme";
import Logo from "../../assets/image/logo_1x.webp";
import Logo2x from "../../assets/image/logo_2x.webp";
import Logo3x from "../../assets/image/logo_3x.webp";
import { ContinuePlay } from "../../components/common/ContinuePlay";
import { GamesCategory } from "../../components/common/GamesCategory";
import { listGameFake } from "../../constants/game";
import { Icon, Image } from "@onmo/ui";
import { login } from "@onmo/auth";

const Guest: React.FC = () => {
  const classes = useStyles();
  const logoHeader = getImage3x("header-logo.webp");

  const onLogin = async () => {
    await login();
  };

  return (
    <div onClick={onLogin}>
      <div className={classes.header}>
        <Icon name="icon-bold-arrow-left-3" />
        <Image
          src={logoHeader?.oneX || Logo}
          src2x={logoHeader?.twoX || Logo2x}
          src3x={logoHeader?.threeX || Logo3x}
          alt="logo"
          className={classes.logo}
        />
      </div>
      <div className={classes.game}>
        <GamesCategory title={"What’s hot"} games={listGameFake} />
        <ContinuePlay
          isTopGame
          label="Top 10 Games"
          games={listGameFake}
          className={classes.continuePlay}
        />
      </div>
    </div>
  );
};

export default Guest;
